export default __webpack_public_path__ + "static/media/team-2.9b507e60.png";